module.exports = __webpack_public_path__ + "img/check.0da30b60.svg";